import type { App } from "vue";
import 'instantsearch.css/themes/algolia-min.css'
import InstantSearch from 'vue-instantsearch/vue3/es'
import '../src/components/vue/assets/style.css'
export default (app: App) => {
    app.use(InstantSearch);
};
